import { http } from "../http-common";

const ManageUnannouncedVisitorService = {
    getCropYears: async () => {
        try {
            const response = await http.get("/cropYears");
            return response;
        } catch (error) {
            throw error;
        }
    },

    getCropStage: async (params ) => {
        try {
            const response = await http.get(`/crop-stage-calendar/crop-stage-calendar-drop-down?cropYear=${params.cropYear}&isSubGrowerMonitoring=false`);
            return response;
        } catch (error) {
            throw error;
        }
    },

     getCropStageSurveyReopen: async (params,config ) => {
        try {
            const isSubGrowerMonitoring = params.isSubGrowerMonitoring ?? false;
            const response = await http.get(`/crop-stage-calendar/crop-stage-calendar-drop-down?cropYear=${params.cropYear}&isSubGrowerMonitoring=${isSubGrowerMonitoring}`,config);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getVisitorList: async (params ,pageNumber ,pageSize) => {
        try {
            const response = await http.post(`/manageUnannouncedVisit/get-farmers?pageNumber=${pageNumber}&pageSize=${pageSize}`, params);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getHierarchyDropdown: async (data) => {
        try {
            const params = new URLSearchParams();
            params.append("isMuv", data.isMuv);
            if (data.cropYear) {
                params.append("cropYear", data.cropYear);
            }

            const response = await http.get(`/hierarchy/hierarchy-drop-down?${params.toString()}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    updateVisitorAssignment: async (visitorData) => {
        try {
            console.log("visitorData", visitorData);
            const response = await http.post("/manageUnannouncedVisit", visitorData);
            return response;
        } catch (error) {
            throw error;
        }
    },
};

export default ManageUnannouncedVisitorService;
